import React, { useState } from "react";
import { formatPercent } from "./utils";

function GenderSection({ summary }) {
  const [activeTooltip, setActiveTooltip] = useState(null);
  const womenDeg = (summary.womenPercent / 100) * 360;
  const menEndDeg = womenDeg + (summary.menPercent / 100) * 360;
  const hasUnknown = summary.unknownPercent > 0;

  const donutBackground = hasUnknown
    ? `conic-gradient(#b39ddb 0deg ${womenDeg}deg, #90caf9 ${womenDeg}deg ${menEndDeg}deg, #e5e7eb ${menEndDeg}deg 360deg)`
    : `conic-gradient(#b39ddb 0deg ${womenDeg}deg, #90caf9 ${womenDeg}deg 360deg)`;

  return (
    <section className="hr-dashboard__card">
      <h2 className="hr-dashboard__section-title">Гендерное соотношение</h2>
      <div className="hr-dashboard__split hr-dashboard__split--gender">
        <div className="hr-dashboard__donut-wrap">
          <div
            className="hr-dashboard__donut"
            style={{ background: donutBackground }}
          >
            <div className="hr-dashboard__donut-hole" />
          </div>
          <div className="hr-dashboard__donut-legend">
            <div className="hr-dashboard__legend-item">
              <span className="hr-dashboard__legend-dot hr-dashboard__legend-dot--women" />
              <span>{formatPercent(summary.womenPercent)} Женщины</span>
            </div>
            <div className="hr-dashboard__legend-item">
              <span className="hr-dashboard__legend-dot hr-dashboard__legend-dot--men" />
              <span>{formatPercent(summary.menPercent)} Мужчины</span>
            </div>
            {hasUnknown && (
              <div className="hr-dashboard__legend-item">
                <span className="hr-dashboard__legend-dot hr-dashboard__legend-dot--unknown" />
                <span>{formatPercent(summary.unknownPercent)} Не указан</span>
              </div>
            )}
          </div>
        </div>

        <div className="hr-dashboard__gender-chart">
          {summary.departments?.length ? (
            <>
              {summary.departments.map((dept) => (
                <div key={dept.id ?? dept.code} className="hr-dashboard__bar-row">
                  <div className="hr-dashboard__bar-label">{dept.name || dept.code}</div>
                  <div
                    className="hr-dashboard__stacked-bar hr-dashboard__stacked-bar--interactive"
                    onMouseEnter={() => setActiveTooltip(dept.code)}
                    onMouseLeave={() => setActiveTooltip(null)}
                  >
                    <div className="hr-dashboard__stacked-bar-inner">
                      <div
                        className="hr-dashboard__stacked-segment"
                        style={{
                          width: `${dept.womenPercent}%`,
                          backgroundColor: "#b39ddb",
                        }}
                      />
                      <div
                        className="hr-dashboard__stacked-segment"
                        style={{
                          width: `${dept.menPercent}%`,
                          backgroundColor: "#90caf9",
                        }}
                      />
                      {dept.unknownPercent > 0 && (
                        <div
                          className="hr-dashboard__stacked-segment"
                          style={{
                            width: `${dept.unknownPercent}%`,
                            backgroundColor: "#e5e7eb",
                          }}
                        />
                      )}
                    </div>
                    {activeTooltip === dept.code && (
                      <div className="hr-dashboard__tooltip">
                        <strong>{dept.code}</strong>
                        <span>Женщины: {formatPercent(dept.womenPercent)}</span>
                        <span>Мужчины: {formatPercent(dept.menPercent)}</span>
                        {dept.unknownPercent > 0 && (
                          <span>
                            Не указан: {formatPercent(dept.unknownPercent)}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
              <div className="hr-dashboard__axis hr-dashboard__axis--percent">
                {[0, 25, 50, 75, 100].map((tick) => (
                  <span key={tick}>{tick}%</span>
                ))}
              </div>
            </>
          ) : (
            <p className="hr-dashboard__empty-state">Нет данных по отделениям</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default GenderSection;
